// @flow
import { ACTIONS } from '../actions';

export const marketplaceProducts = (
    state: {} = [],
    action: { type: string, products: [] }
): {} => {
    switch (action.type) {
        case ACTIONS.LOAD_MARKETPLACE_PRODUCTS:
            return [...action.products];
        default:
            return state;
    }
};
